const action = require('../action/action');

const popupIframe = Object.assign({}, action, {
    modal: false,

    act: function () {
        
        if (this.disabled) {
            return false;
        }

        this.element.setAttribute("data-zit-indicator", "on");

        if (this.modal === false) {
            this.createModal();
        }

        this.modal.open();

        this.element.removeAttribute("data-zit-indicator");
    },

    createModal: function () {

        this.modal = this.hm.newComponent('modal');
        this.modal.init();
        this.modal.inited();

        let modalSize = typeof this.extraAttributes.modalSize !== typeof undefined ? this.extraAttributes.modalSize : 'lg';
        
        this.modal.setSize(modalSize);

        this.modal.setTitle(this.element.title);

        let iframeHtml = '<iframe class="zit-w-100 modal-iframe" src="' + this.link + '" data-backdrop="static" data-keyboard="false"></iframe>';

        let iframeElement = this.hm.helper.string2element(iframeHtml);

        this.modal.appendContent(iframeElement);
    }
});

module.exports = popupIframe